/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateScriptRequest
 */
export interface UpdateScriptRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateScriptRequest
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the UpdateScriptRequest interface.
 */
export function instanceOfUpdateScriptRequest(value: object): boolean {
    return true;
}

export function UpdateScriptRequestFromJSON(json: any): UpdateScriptRequest {
    return UpdateScriptRequestFromJSONTyped(json, false);
}

export function UpdateScriptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScriptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function UpdateScriptRequestToJSON(value?: UpdateScriptRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'isDefault': value['isDefault'],
    };
}

